import { jsx as _jsx } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import cn from 'classnames';
export const Empty = ({ text, variant, indent }) => {
    const isComputerInbox = variant === 'computerInbox';
    const isProjectThread = indent === 'projectThread';
    const horizontalOffsetClass = isProjectThread
        ? 'ml-[calc(1rem+var(--spacing-2)+var(--spacing-2)+2px)] mr-3'
        : isComputerInbox
            ? 'ml-[calc(var(--spacing-2)+2px)] mr-3'
            : 'mx-3';
    return (_jsx(TextPrimitive, { color: "ultraLight", size: isComputerInbox ? 'sm' : 'xs', selection: "none", className: cn('flex items-center whitespace-nowrap truncate h-7', horizontalOffsetClass, isComputerInbox && 'opacity-70'), children: text }));
};
//# sourceMappingURL=Empty.js.map